import { Navigate } from "react-router-dom";
import { useModuleSettings } from "@/hooks/useModuleSettings";
import KycTierGate from "@/components/KycTierGate";

interface ModuleGuardProps {
  moduleKey: string;
  children: React.ReactNode;
  /** Where to send the user when the module is disabled/hidden. */
  redirectTo?: string;
}

export default function ModuleGuard({ moduleKey, children, redirectTo = "/app/dashboard" }: ModuleGuardProps) {
  const { isModuleEnabled, getModuleMinTier, isLoading } = useModuleSettings();

  if (isLoading) return null;
  if (!isModuleEnabled(moduleKey)) return <Navigate to={redirectTo} replace />;


  const minTier = getModuleMinTier(moduleKey);
  if (minTier > 0) {
    return (
      <KycTierGate requiredTier={minTier} featureLabel={moduleKey.replace(/_/g, " ")}>
        {children}
      </KycTierGate>
    );
  }

  return <>{children}</>;
}
